import { useEffect } from "react";

const useProductPageScrollEffects = ({
  location,
  reviews,
  setEditingReview,
  setEditReviewForm,
  loading,
  product,
}) => {
  useEffect(() => {
    if (!location.state?.editReviewId) return;

    setEditingReview(location.state.editReviewId);
    const reviewToEdit = reviews.find((r) => r._id === location.state.editReviewId);
    if (!reviewToEdit) return;

    setEditReviewForm({
      rating: reviewToEdit.rating,
      comment: reviewToEdit.comment,
    });

    const reviewsSection = document.getElementById("reviews");
    if (reviewsSection) {
      reviewsSection.scrollIntoView({ behavior: "smooth" });
    }
  }, [location.state, reviews, setEditingReview, setEditReviewForm]);

  useEffect(() => {
    if (loading || !product || !location.hash) return;

    const elementId = location.hash.substring(1);
    const element = document.getElementById(elementId);
    if (!element) return;

    setTimeout(() => {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  }, [loading, product, location.hash]);
};

export default useProductPageScrollEffects;
